<script>
import { mapGetters } from "vuex";

export default {
  name: "Bahn1Agenda",
  computed: {
    ...mapGetters("bahn1", ["eventProgramm"]),
    programmItems() {
      const items = this.eventProgramm ? this.eventProgramm.ProgrammItems : [];
      return items.filter(
        item =>
          item.Thema ||
          item.ReferentInnen ||
          item.Thema2 ||
          item.ReferentInnen2 ||
          item.Label
      );
    }
  },
  methods: {
    formatTime(time) {
      return time ? time.slice(0, 5) : "";
    },
    agendaOptions(item) {
      return [
        { Thema: item.Thema, ReferentInnen: item.ReferentInnen },
        { Thema: item.Thema2, ReferentInnen: item.ReferentInnen2 }
      ].filter(option => option.Thema || option.ReferentInnen);
    }
  }
};
</script>

<template>
  <div class="agenda" v-if="programmItems.length">
    <table class="agenda-table">
      <thead>
        <tr>
          <th class="col-time">Uhrzeit</th>
          <th class="col-thema">Thema</th>
          <th class="col-referenten">Referent:innen</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(item, index) in programmItems"
          :key="index"
          :class="{ 'agenda-row--accent': index % 2 === 0 }"
        >
          <td class="cell-time">{{ formatTime(item.Uhrzeit) }}</td>
          <td colspan="2" class="cell-options">
            <span v-if="item.Label" class="agenda-label">{{ item.Label }}</span>
            <div
              v-for="(option, optionIndex) in agendaOptions(item)"
              :key="optionIndex"
              class="agenda-option-row"
            >
              <span class="agenda-thema">{{ option.Thema }}</span>
              <span class="agenda-referenten">{{ option.ReferentInnen }}</span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style scoped>
.agenda {
  width: 100%;
  margin-bottom: 56px;
}
.agenda-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-family: "GeometriaLight", sans-serif;
}
.agenda-table th,
.agenda-table td {
  text-align: left;
  vertical-align: top;
  padding: 11px 0px 10px 16px;
}
.agenda-table th {
  letter-spacing: 0.6px;
  font-size: 12px;
}
.agenda-row--accent {
  background: #dcecf7;
}
.agenda-label {
  display: block;
  width: calc(50% - 8px);
  font-size: 10px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  font-family: "GeometriaGeometria";
  margin-bottom: 8px;
}
.agenda-option-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  column-gap: 16px;
}
.agenda-option-row + .agenda-option-row {
  margin-top: 16px;
}
.agenda-thema {
  font-family: "GeometriaMedium";
  letter-spacing: 0.32px;
}
.agenda-referenten {
  letter-spacing: 0.32px;
}
.col-time,
.cell-time {
  width: 10%;
  letter-spacing: 0.32px;
}
.col-thema,
.col-referenten {
  width: 45%;
}
</style>
